import Actions                from 'Redux/Actions';
import { InvoiceRepository }  from 'Domain/Repositories';
import { ofType }             from 'redux-observable';
import { from, EMPTY }        from 'rxjs';
import { mergeMap }           from 'rxjs/operators';
import { TEpic }              from 'Redux/Config';

export const downloadTicketsFromInvoiceEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.downloadTicketsFromInvoiceRequest.type),
    mergeMap(action => {
      const { id } = action.payload;

      if (!id.trim()) {
        return EMPTY;
      }

      return from(
        InvoiceRepository.downloadTicketsFromInvoice(id)
          .then(() => {
            return Actions.downloadTicketsFromInvoiceSuccess();
          })
          .catch((error: any) => Actions.downloadTicketsFromInvoiceFailure({ error })),
      );
    }),
  );
};
